export default {
    methods: {
        editWholesaleDiscounts() {
            let basePath = this.$route.fullPath
            this.$router.push({ path: `${basePath}/wholesale_discounts` })
        },
    },
}
